export default {
  // 获取时间相差多少小时
  getInervalHour(startDate, endDate) {
    var ms = endDate.getTime() - startDate.getTime()
    if (ms < 0) return 0
    return Math.floor(ms / 1000 / 60 / 60)
  },
  // 联动拼接
  setLink(data) {
    data.linkConditions.map(linkCondition => {
      if (linkCondition.columnType == 'DATE') {
        if (data.dimensions.some(v => v.chinese == linkCondition.chinese)) {
          let uuid = data.dimensions.find(v => v.chinese == linkCondition.chinese).uuid
          linkCondition.uuid = uuid
          data.conditions.map(v => {
            if (v.uuid == linkCondition.uuid) {
              if (v.queryType == 'LARGE' || v.queryType == 'LARGEEQUAL') {
                v.queryType = 'LARGEEQUAL'
                v.requestValue[0] = linkCondition.data[0]
              }
              if (v.queryType == 'LESS' || v.queryType == 'LESSEQUAL') {
                v.queryType = 'LESSEQUAL'
                if (linkCondition.data.length > 1) {
                  v.requestValue[0] = linkCondition.data[1]
                } else {
                  v.requestValue[0] = linkCondition.data[0]
                }
              }
            }
          })
        } else {
          const conditionStart = {
            queryType: 'LARGEEQUAL',
            requestValue: [linkCondition.data[0]],
            uuid: linkCondition.uuid
          }
          const conditionEnd = {
            queryType: 'LESSEQUAL',
            requestValue: [linkCondition.data[1] ? linkCondition.data[1] : linkCondition.data[0]],
            uuid: linkCondition.uuid
          }
          data.conditions.push(...[conditionStart, conditionEnd])
        }
      } else {
        if (data.conditions.some(v => v.uuid == linkCondition.uuid)) {
          data.conditions.map(v => {
            if (v.uuid == linkCondition.uuid) {
              v.requestValue = linkCondition.data
            }
          })
        } else {
          const condition = {
            queryType: 'IN',
            requestValue: linkCondition.data,
            uuid: linkCondition.uuid
          }
          data.conditions.push(condition)
        }
      }
    })
    return data
  },
  // 下钻字段拼接 -- 这么写本身就有毒
  setDirll(data) {
    // 判断下钻数组内是否有有值数据 如果有
    if (data.dirlls && data.dirlls.length && data.dirlls.some(v => v.curDirll)) {
      // 设置当前目标值
      let curDirllIndex = 0
      // map处理数据， 这里这么做不好
      data.dirlls.map((v, i) => {
        // 对有值数组项处理
        if (v.curDirll) {
          // 记录该位置
          curDirllIndex = i
          // 判断条件conditions内是否能匹配到下钻
          if (data.conditions.some(vv => vv.uuid == v.uuid && v.queryType === vv.queryType)) {
            // 如果类型为String 从data.conditions找到uuid匹配的数据 把 下钻的内容写入condition  --这里恶心
            if (v.columnType == 'STRING') {
              const condition = data.conditions.find(vv => v.uuid == vv.uuid)
              condition.requestValue = [v.curDirll]
            } else if (v.columnType == 'HOUR') {
              const condition = data.conditions.find(vv => v.uuid == vv.uuid)
              condition.requestValue = [v.curDirll]
            } else if (v.columnType == 'DATE') {
              // 如果类型为DATE , 下面这么写怪异 为的是日期需要开始和结束时间，需要condition带上俩条数据，传參肯定是严格控制了顺序
              const conditionIndex = data.conditions.findIndex(vv => v.uuid == vv.uuid)
              data.conditions[conditionIndex].requestValue = [v.curDirll]
              data.conditions[conditionIndex + 1].requestValue = [v.curDirll]
              data.conditions[conditionIndex].queryType = 'LARGEEQUAL'
              data.conditions[conditionIndex + 1].queryType = 'LESSEQUAL'
            }
          } else {
            // 如果没有匹配到对应的condition 则添加
            if (v.columnType == 'STRING') {
              data.conditions.push({
                queryType: 'IN',
                requestValue: [v.curDirll],
                uuid: v.uuid
              })
            } else if (v.columnType == 'HOUR') {
              data.conditions.push({
                queryType: 'IN',
                requestValue: [v.curDirll],
                uuid: v.uuid
              })
            } else if (v.columnType == 'DATE') {
              data.conditions.push({
                queryType: 'LARGEEQUAL',
                requestValue: [v.curDirll],
                uuid: v.uuid
              })
              data.conditions.push({
                queryType: 'LESSEQUAL',
                requestValue: [v.curDirll],
                uuid: v.uuid
              })
            }
          }
        }
      })
      data.dimensions.splice(0, 1, data.dirlls[curDirllIndex + 1])
    }
    return data
  },
  formateDataToChart(data, dimLength, numlength) {
    try {
      // 8px移动端字体1px的宽度
      const fontSize = 7.2
      // 根据字体个数匹配表格宽度
      function changeFontToWidth(str) {
        // m为字符串长度
        var m = 0
        var a = (str && str.split('')) || []
        for (var i = 0; i < a.length; i++) {
          if (a[i].charCodeAt(0) < 299) {
            m++
          } else {
            m += 2
          }
        }
        // 16为数据表格的padding加上排序块得宽度
        return m * fontSize + 16
      }
      const setUnit = (formateType, measureSymbol) => {
        if (formateType === 'PERCENT') {
          return '{value}%'
        } else if (measureSymbol === 'DOLLAR') {
          return '${value}'
        } else {
          return '{value}'
        }
      }
      // 先初始化表头宽度
      data.wapFontList = !!data.columnMetas && data.columnMetas.map(v => changeFontToWidth(v.chinese))
      let formatter = ''
      // 表格数据
      const tableOptions = []

      const lineOptions = {
        // dataZoom: data.results.length > 20 ? {
        //     type: 'slider',//图表下方的伸缩条
        //     show: true, //是否显示
        //     realtime: true, //拖动时，是否实时更新系列的视图
        //     start: 0, //伸缩条开始位置（1-100），可以随时更改
        //     end: 100, //伸缩条结束位置（1-100），可以随时更改
        // } : null,
        tooltip: {
          trigger: 'axis',
          confine: false
          // formatter: `{b0}<br />{a0}: {c0} $<br />{a1}: {c1} $`
        },
        grid: {
          top: 60,
          left: 20,
          right: 20,
          bottom: 20,
          containLabel: true
        },
        legend: {
          type: 'scroll',
          data: [],
          top: 18,
          itemWidth: 12,
          itemHeight: 8,
          width: '85%'
        },
        toolbox: {
          show: true,
          right: 20,
          feature: {
            brush: {
              show: false,
              type: ['lineX'],
              title: {
                lineX: '区域选择'
              }
            }
          }
        },
        brush: {
          throttleType: 'debounce',
          throttleDelay: 400,
          brushStyle: {
            borderWidth: 1,
            color: 'rgba(51,136,255,0.13)',
            borderColor: 'rgba(51,136,255,0.45)'
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: []
        },
        // yAxis: {
        //     nameRotate: 90,
        //     nameLocation: "middle",
        //     nameGap: 80,
        // },
        yAxis: [],
        series: []
      }
      const barOptions = {
        // dataZoom: data.results.length > 20 ? [{
        //     type: 'slider',//图表下方的伸缩条
        //     show: true, //是否显示
        //     realtime: true, //拖动时，是否实时更新系列的视图
        //     start: 0, //伸缩条开始位置（1-100），可以随时更改
        //     end: 100, //伸缩条结束位置（1-100），可以随时更改
        // }] : [],
        grid: {
          top: 60,
          left: '4%',
          right: '6%',
          bottom: 20,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          confine: false
        },
        legend: {
          type: 'scroll',
          data: [],
          top: 18,
          itemWidth: 12,
          itemHeight: 8,
          width: '85%'
        },
        toolbox: {
          show: true
        },
        calculable: true,
        xAxis: {
          type: 'category',
          data: []
        },
        // yAxis: {
        //     type: 'value'
        // },
        yAxis: [],
        series: []
      }
      // 饼图
      const pieOptions = {
        tooltip: {
          trigger: 'item',
          formatter: '{b} :<br> {c} ({d}%)'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: '5%',
          data: [],
          itemWidth: 12,
          itemHeight: 8,
          top: 10,
          bottom: 10
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '55%',
            top: '20%',
            center: ['25%', '50%'],
            data: [],
            hoverAnimation: true,
            label: {
              normal: {
                show: false,
                // formatter: '{c}\n({d}%)'
                position: 'inside'
              },

              emphasis: {
                label: {
                  show: true
                },
                show: true,
                textStyle: {
                  fontSize: '14'
                },
                formatter: '{c}\n({d}%)'
              }
            },
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      const funnelOptions = {
        tooltip: {
          trigger: 'item',
          formatter: '{c} ({d}%)'
        },
        toolbox: {
          // feature: {
          //     dataView: {
          //         readOnly: false
          //     },
          //     restore: {},
          //     saveAsImage: {}
          // }
        },
        legend: {
          type: 'scroll',
          data: [],
          top: 18,
          itemWidth: 12,
          itemHeight: 8,
          width: '85%'
        },
        calculable: true,
        series: [
          {
            name: '',
            type: 'funnel',
            left: '15%',
            top: 60,
            bottom: 10,
            width: '70%',
            min: 0,
            // max: 100,
            minSize: '1%',
            maxSize: '100%',
            sort: 'descending',
            gap: 2,
            // markLine: {
            //     symbol: 'none',
            //     lineStyle: { type: 'solid' },
            //     data: [{ x: '0%', y: '18%' }, { x: '10%', y: '18%', value: '一个' }]
            // },
            label: {
              normal: {
                position: 'inside'
              },
              emphasis: {
                textStyle: {
                  fontSize: 12
                }
              }
            },
            itemStyle: {
              normal: {
                borderColor: '#fff',
                borderWidth: 1
              }
            },
            data: []
          }
        ]
      }
      const lineAndBarOptions = {
        grid: {
          top: 60,
          left: 10,
          right: 10,
          bottom: 20,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        toolbox: {},
        xAxis: {
          type: 'category',
          // boundaryGap: true,
          data: []
        },
        yAxis: [],
        legend: {
          type: 'scroll',
          data: [],
          top: 18,
          itemWidth: 12,
          itemHeight: 8,
          width: '85%'
        },
        series: []
      }
      const indexOptions =
        dimLength == 0 && numlength == 1 && data.results.length
          ? {
              name: data.columnMetas[0].chinese,
              value: data.results[0][0]
            }
          : {}
      !!data.results &&
        data.results.map((v, i) => {
          const obj = {}
          data.columnMetas &&
            data.columnMetas.map((vv, ii) => {
              const columnData = vv.measure ? String(v[ii]) : String(v[ii])
              if (!obj.hasOwnProperty(vv.chinese)) {
                obj[vv.chinese] = columnData
              } else {
                let nullData = ''
                for (let j = 0; j <= ii; j++) {
                  nullData += ' '
                }
                obj[vv.chinese + nullData] = columnData
              }
              if (v[ii] == null) {
                v[ii] = ''
              }
              if (data.wapFontList[ii] < changeFontToWidth(v[ii])) {
                data.wapFontList[ii] = changeFontToWidth(v[ii]) > 200 ? 200 : changeFontToWidth(v[ii])
              }
            })
          tableOptions.push(obj)
        })
      // console.log(data)
      // 折线图和柱形图的数据。
      if (dimLength == 1 && numlength != 0) {
        data.columnMetas &&
          data.columnMetas.map((v, i) => {
            if (i != 0) {
              lineOptions.legend.data.push(v.chinese)
              lineOptions.series.push({
                name: v.chinese,
                type: 'line',
                data: []
              })
              barOptions.legend.data.push(v.chinese)
              barOptions.series.push({
                name: v.chinese,
                type: 'bar',
                data: []
              })
              lineAndBarOptions.legend.data.push(v.chinese)
              if (numlength === 2) {
                if (i === 1) {
                  lineAndBarOptions.series.push({
                    name: v.chinese,
                    type: 'bar',
                    data: []
                  })
                  lineAndBarOptions.yAxis.push({
                    name: v.chinese,
                    type: 'value',
                    axisLabel: {
                      formatter: setUnit(v.formateType, v.measureSymbol)
                    }
                  })
                  lineOptions.yAxis.push({
                    name: v.chinese,
                    type: 'value',
                    axisLabel: {
                      formatter: setUnit(v.formateType, v.measureSymbol)
                    }
                  })
                  barOptions.yAxis.push({
                    name: v.chinese,
                    type: 'value',
                    axisLabel: {
                      formatter: setUnit(v.formateType, v.measureSymbol)
                    }
                  })
                } else {
                  lineAndBarOptions.series.push({
                    name: v.chinese,
                    type: 'line',
                    data: [],
                    yAxisIndex: 1
                  })
                  lineAndBarOptions.yAxis.push({
                    name: v.chinese,
                    type: 'value',
                    position: 'right',
                    axisLabel: {
                      formatter: setUnit(v.formateType, v.measureSymbol)
                    }
                  })
                  lineOptions.yAxis.push({
                    name: v.chinese,
                    type: 'value',
                    position: 'right',
                    axisLabel: {
                      formatter: setUnit(v.formateType, v.measureSymbol)
                    }
                  })
                  barOptions.yAxis.push({
                    name: v.chinese,
                    type: 'value',
                    position: 'right',
                    axisLabel: {
                      formatter: setUnit(v.formateType, v.measureSymbol)
                    }
                  })
                }
              } else {
                if (i === 1) {
                  lineAndBarOptions.yAxis.push({
                    name: v.chinese,
                    type: 'value',
                    axisLabel: {
                      formatter: setUnit(v.formateType, v.measureSymbol)
                    }
                  })
                  lineOptions.yAxis.push({
                    name: v.chinese,
                    type: 'value',
                    axisLabel: {
                      formatter: setUnit(v.formateType, v.measureSymbol)
                    }
                  })
                  barOptions.yAxis.push({
                    name: v.chinese,
                    type: 'value',
                    axisLabel: {
                      formatter: setUnit(v.formateType, v.measureSymbol)
                    }
                  })
                }
              }
            }
            // i != 0 && lineOptions.legend.data.push(v.chinese) && lineOptions.series.push({
            //     name: v.chinese,
            //     type: 'line',
            //     data: [],
            // }) && barOptions.legend.data.push(v.chinese) && barOptions.series.push({
            //     name: v.chinese,
            //     type: 'bar',
            //     data: []
            // }) && lineAndBarOptions.legend.data.push(v.chinese) && lineAndBarOptions.series.push({
            //     name: v.chinese,
            //     type: 'bar',
            //     data: []
            // })
          })
        data.results &&
          data.results.map((v, i) => {
            lineOptions.xAxis.data.push(v[0])
            barOptions.xAxis.data.push(v[0])
            lineAndBarOptions.xAxis.data.push(v[0])
            lineOptions.series.map((vv, ii) => {
              vv.data.push(v[ii + 1])
            })
            barOptions.series.map((vv, ii) => {
              vv.data.push(v[ii + 1])
            })
            lineAndBarOptions.series.map((vv, ii) => {
              vv.data.push(v[ii + 1])
            })
            // 饼图,漏斗图情况
            if (numlength == 1) {
              pieOptions.series[0].data.push({
                value: v[1],
                name: v[0]
              }) &&
                pieOptions.legend.data.push(v[0]) &&
                funnelOptions.legend.data.push(v[0]) &&
                funnelOptions.series[0].data.push({
                  value: v[1],
                  name: v[0]
                })
              pieOptions.series[0].name = data.columnMetas[1].chinese
              funnelOptions.series[0].name = data.columnMetas[1].chinese
            }
            if (funnelOptions.series[0].max < Number(v[1])) {
              funnelOptions.series[0].max = Number(v[1])
            }
          })
      } else if (dimLength == 2 && numlength == 1) {
        // const dim1LengthList = [...new Set(data.results.map(v=>{
        //     return v[0]
        // }))]
        // const dim2LengthlList = [...new Set(data.results.map(v => {
        //     return v[1]
        // }))]
        // dim1LengthList.map(v=>{
        //     dim2LengthlList.map(vv=>{
        //         if(!data.results.some(vvv=>vvv[0] == v && vvv[1] === vv)){
        //             console.log([v, vv, null])
        //             data.results.push([v,vv,null])
        //         }
        //     })
        // })
        // console.log(data.results)
        // 二维一指标  只有柱状图跟线性图支持
        data.results &&
          data.results.map(v => {
            // 假设没有，则push
            if (lineOptions.legend.data.every(vv => vv != v[1])) {
              lineOptions.legend.data.push(v[1])
              barOptions.legend.data.push(v[1])
              lineOptions.series.push({
                name: v[1],
                type: 'line',
                data: []
              })
              barOptions.series.push({
                name: v[1],
                type: 'bar',
                data: []
              })
            }
            if (lineOptions.xAxis.data.every(vv => vv != v[0])) {
              lineOptions.xAxis.data.push(v[0])
              barOptions.xAxis.data.push(v[0])
            }
          })

        // 兼容第二维度没有数据问题
        lineOptions.series.map((v, i) => {
          lineOptions.xAxis.data.map(vv => {
            const hasResult = data.results.find(vvv => vvv[0] == vv && vvv[1] == v.name)
            if (hasResult) {
              v.data.push(hasResult[2])
              barOptions.series[i].data.push(hasResult[2])
            } else {
              v.data.push(null)
              barOptions.series[i].data.push(null)
            }
          })
        })
        lineOptions.yAxis.push({
          name: data.columnMetas[2].chinese,
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        })
        barOptions.yAxis.push({
          name: data.columnMetas[2].chinese,
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        })
      } else if (dimLength == 0 && numlength != 0) {
        let max = 0
        // 漏斗图展示多指标
        data.columnMetas.map((v, i) => {
          funnelOptions.legend.data.push(v.chinese)
          if (Number(data.results[0][i]) > max) {
            max = Number(data.results[0][i])
          }
          funnelOptions.series[0].data.push({
            value: data.results[0][i],
            name: v.chinese
          })
        })
        funnelOptions.series[0].max = max
        funnelOptions.series[0].name = '数据'
      }
      const returnOptions = {
        // totalResult: data.totalResult,
        table: tableOptions,
        line: lineOptions,
        bar: barOptions,
        pie: pieOptions,
        funnel: funnelOptions,
        index: indexOptions,
        lineAndBar: lineAndBarOptions
      }
      return returnOptions
    } catch (e) {
      console.log('error: format data report::', e)
    }
  }
}
